// extracted by mini-css-extract-plugin
export default {"main":"Score_main__d1Ite","comp":"Score_comp__ZuFK7","human":"Score_human__Nyv+3","time":"Score_time__18Pky","red":"Score_red__58uRs"};